import { ref, computed } from "vue";
const createFormContext = (options) => {
  const fields = ref(/* @__PURE__ */ new Map());
  return {
    // Vue unwrap ref automatically, but types are not for some reason
    immediate: computed(() => options.immediate),
    fields: computed(() => [...fields.value.values()]),
    forceHideErrors: computed(() => options.hideErrors),
    forceHideErrorMessages: computed(() => options.hideErrorMessages),
    forceHideLoading: computed(() => options.hideLoading),
    forceDirty: ref(false),
    registerField: (uid, field) => {
      fields.value.set(uid, field);
    },
    unregisterField: (uid) => {
      fields.value.delete(uid);
    }
  };
};
export {
  createFormContext as c
};
//# sourceMappingURL=formContext.js.map
